(function () {
  'use strict';
  if (window.__vgBehaviorTracking) return;
  window.__vgBehaviorTracking = true;
  var configNode = document.getElementById('vg-tracking-config');
  if (!configNode || (window.Shopify && window.Shopify.designMode)) return;
  var config;
  try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
  var root = document.querySelector('.vg-pdp[data-vg-product-id]');
  var productNode = root && root.querySelector('[data-vg-tracking-product]');
  var product = {};
  try { if (productNode) product = JSON.parse(productNode.textContent); } catch (_) {}
  var seen = new Set();
  var lastEvents = Object.create(null);
  var activeSeconds = 0;
  var lastTick = performance.now();
  var lastInteraction = lastTick;
  var seq = 0;
  var pageId = Date.now().toString(36) + Math.random().toString(36).slice(2, 9);
  function allowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!privacy && privacy.analyticsProcessingAllowed() === true &&
        privacy.marketingAllowed() === true && privacy.saleOfDataAllowed() === true;
    } catch (_) { return false; }
  }
  function send(name, data, standard, once) {
    if (!allowed() || typeof window.fbq !== 'function' || !window.fbq.callMethod) return false;
    if (once && seen.has(once)) return false;
    var now = performance.now();
    var signature = name + JSON.stringify(data || {});
    if (lastEvents[signature] !== undefined && now - lastEvents[signature] < 750) return false;
    try {
      window.fbq(standard ? 'trackSingle' : 'trackSingleCustom', config.pixel, name,
        Object.assign({page_type: config.page_type, tracking_version: 'vg_1'}, data || {}),
        {eventID: 'vg-' + pageId + '-' + (++seq)});
      lastEvents[signature] = now;
      if (once) seen.add(once);
      return true;
    } catch (_) { return false; }
  }
  function selection() {
    if (!root) return {};
    var selected = root.querySelector('input[data-pack-quantity]:checked');
    var subscription = root.querySelector('[data-vg-subscribe]');
    if (!selected) return {};
    var sub = !!(subscription && subscription.checked);
    return {
      content_ids: [selected.dataset.variantId], content_type: 'product',
      currency: product.currency || config.currency,
      value: Number(sub ? selected.dataset.subCents : selected.dataset.oneCents) / 100,
      pack_quantity: Number(selected.dataset.packQuantity),
      purchase_option: sub ? 'subscription' : 'one_time'
    };
  }
  function viewProduct() {
    if (!root || config.page_type === 'product') return;
    var data = selection();
    if (!data.content_ids || !data.content_ids[0] || !Number.isFinite(data.value)) return;
    send('ViewContent', Object.assign({content_name: product.name}, data), true, 'product-view');
  }
  function scrollDepth() {
    if (!root || !allowed()) return;
    var distance = document.documentElement.scrollHeight - window.innerHeight;
    if (distance <= 0) return;
    var depth = Math.min(100, Math.round(window.scrollY / distance * 100));
    [25, 50, 75, 90].forEach(function (threshold) {
      if (depth >= threshold) send('VGScrollDepth', {percent: threshold}, false, 'scroll-' + threshold);
    });
  }
  var legacy = {
    'cart-drawer-open': 'VGCartOpened', 'cart-drawer-close': 'VGCartClosed',
    'cart-item-remove': 'VGRemoveFromCartClicked', 'cart-qty-up': 'VGCartQuantityIncreased',
    'cart-qty-down': 'VGCartQuantityDecreased', 'checkout-click': 'VGCheckoutClicked',
    'atc-result': 'VGCartAddResult', 'menu-drawer-open': 'VGMenuOpened',
    'video-play': 'VGVideoPlayed', 'video-quartile': 'VGVideoProgress',
    'gallery-zoom': 'VGGalleryZoomed', 'review-slider-nav': 'VGReviewNavigation'
  };
  window.VGTrackLegacy = function (name, value, detail) {
    if (!Object.prototype.hasOwnProperty.call(legacy, name)) return;
    var data = {};
    if (name === 'atc-result') data.result = detail === 'ok' ? 'success' : 'error';
    if (name === 'video-quartile' && Number.isFinite(value)) data.percent = value * 25;
    send(legacy[name], data);
  };
  document.addEventListener('change', function (event) {
    if (!root || !root.contains(event.target)) return;
    if (event.target.matches('input[data-pack-quantity]')) send('VGBundleSelected', selection());
    if (event.target.matches('[data-vg-subscribe]')) send('VGPurchaseOptionSelected', selection());
  });
  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var target = event.target;
    if (target.closest('[data-vg-atc]')) send('VGAddToCartClicked', selection());
    if (target.closest('[data-vg-sticky-cta]')) send('VGStickyOfferClicked', selection());
    var gallery = target.closest('[data-vg-thumb], [data-vg-prev], [data-vg-next]');
    if (gallery && root) {
      var index = Array.from(root.querySelectorAll('[data-vg-thumb]')).indexOf(gallery);
      send('VGGalleryInteraction', {action: index >= 0 ? 'thumbnail' : gallery.hasAttribute('data-vg-prev') ? 'previous' : 'next', image_index: index >= 0 ? index + 1 : 0});
    }
    var slider = target.closest('[data-vg-slider-prev], [data-vg-slider-next]');
    if (slider) {
      var controls = slider.closest('[data-vg-slider-controls]');
      var sliderName = controls && controls.getAttribute('data-vg-slider-controls');
      if (sliderName === 'reviews' || sliderName === 'formula') send('VGSliderInteraction', {section: sliderName, direction: slider.hasAttribute('data-vg-slider-prev') ? 'previous' : 'next'});
    }
  });
  if (root) {
    root.querySelectorAll('details').forEach(function (details, index) {
      details.addEventListener('toggle', function () {
        if (details.open) send('VGAccordionOpened', {item_index: index + 1}, false, 'accordion-' + index);
      });
    });
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var sectionName = entry.target.dataset.vgTrackingSection;
          if (send('VGSectionViewed', {section: sectionName}, false, 'section-' + sectionName)) observer.unobserve(entry.target);
        });
      }, {threshold: 0.15});
      ['reviews', 'formula-proof', 'daily-support', 'routine-journey', 'faq'].forEach(function (name) {
        var section = root.querySelector('.vg-' + name);
        if (section) { section.dataset.vgTrackingSection = name; observer.observe(section); }
      });
      document.addEventListener('visitorConsentCollected', function () {
        root.querySelectorAll('[data-vg-tracking-section]').forEach(function (section) { observer.unobserve(section); observer.observe(section); });
      });
    }
  }
  ['pointerdown', 'keydown', 'scroll', 'touchstart'].forEach(function (name) {
    document.addEventListener(name, function () { lastInteraction = performance.now(); }, {passive: true});
  });
  window.addEventListener('scroll', scrollDepth, {passive: true});
  document.addEventListener('visitorConsentCollected', function () { lastTick = performance.now(); viewProduct(); });
  try {
    if (window.Shopify && !window.Shopify.customerPrivacy && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], function (error) { if (!error) viewProduct(); });
    }
  } catch (_) {}
  viewProduct();
  window.setInterval(function () {
    var now = performance.now();
    var elapsed = Math.min((now - lastTick) / 1000, 2);
    lastTick = now;
    if (!allowed()) return;
    viewProduct();
    if (!document.hidden && now - lastInteraction < 60000) activeSeconds += elapsed;
    if (root) [30, 60, 120, 300].forEach(function (seconds) {
      if (activeSeconds >= seconds) send('VGEngagedTime', {seconds: seconds}, false, 'time-' + seconds);
    });
  }, 1000);
})();
